import AdvertiseAndEditorsPick from "./components/AdvertiseAndEditorsPick/AdvertiseAndEditorsPick";
import BannerStylee from "./components/Banner/BannerStylee";
import CateogaryBlock from "./components/CateogaryBlock/CateogaryBlock";
import CateogaryWise from "./components/CateogaryWise/CateogaryWise";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import NewsLetter from "./components/NewzLetter/NewsLetter";
import PopularPosts from "./components/PopularPosts/PopularPosts";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Error from "./components/ErrorPage/Error";
import Post from "./components/Posts/Post";
import RecentPosts from "./components/RecentPosts/RecentPosts";
import Contact from "./components/Contact/Contact";
import BlockSearch from "./components/BlockSearch/BlockSearch";
import Blogs from "./components/Blogs/Blogs";
import Search from "./components/SearchComponent/Search";
import AboutMe from "./components/AboutMe/AboutMe";

function App() {

  return (
    <>
      <Header />
      <Router>
        <Switch>
          <Route exact path='/'>
            <CateogaryBlock />
            <BannerStylee />
            <AdvertiseAndEditorsPick />
            <PopularPosts />
            <CateogaryWise />
            <RecentPosts />
            <NewsLetter />
          </Route>
          <Route exact path='/posts/:name' component={Post} />
          <Route exact path='/contact' component={Contact} />
          <Route exact path='/cateogary/:cat' component={BlockSearch} />
          <Route exact path='/hashtag/:cat' component={BlockSearch} />
          <Route exact path='/blogs' component={Blogs} />
          <Route exact path='/search/:query' component={Search} />
          <Route exact path='/about Me' component={AboutMe} />
          <Route component={Error} />
        </Switch>
      </Router>
      <Footer />
    </>
  );
}

export default App;
